<!-- Standard Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Standard Modal Body -->
<div class="modal-body" [hidden]="minimise">

  <!-- Issue Dropdown (EXAM scenario) -->
  <form name="allocForm" id="allocForm">
    <table style="width: fit-content">
      <tr>
        @if (issueList.length > 0 && issueList[0].SCENARIO_TYPE_CODE === 'EXAM') {
<td>
          <h5><b><font color="00008b">Please select an issue from the list:&nbsp;&nbsp;</font></b></h5>
        </td>
}
        <td>
          @if (issueList.length > 0 && issueList[0].SCENARIO_TYPE_CODE === 'EXAM') {
<select
                  [ngModel]="selectedIssue"
                  (ngModelChange)="selectedIssue = $event"
                  class="form-control">
            @for (issue of issueList; track $index) {
<option [value]="issue.ISSUE_ID_SHORT_DESC">{{issue.ISSUE_ID_SHORT_DESC}}</option>
}
          </select>
}
        </td>
      </tr>
      <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
    </table>

    <!-- Tab Navigation -->
    <ul class="nav nav-pills" role="tablist">
      <li [class.active]="activeTab === 'TI'">
        <a (click)="activeTab = 'TI'" style="cursor: pointer;" class="btn-sm">TI / Other Info</a>
      </li>
      <li [class.active]="activeTab === 'FTC'" [class.disabled]="ftcTabDisabled">
        <a (click)="!ftcTabDisabled && (activeTab = 'FTC')" style="cursor: pointer;" class="btn-sm">FTC</a>
      </li>
      <li [class.active]="activeTab === 'FSI_GI'" [class.disabled]="ftcGITabDisabled">
        <a (click)="!ftcGITabDisabled && (activeTab = 'FSI_GI')" style="cursor: pointer;" class="btn-sm">FTC - Gross Income Detail</a>
      </li>
      <li [class.active]="activeTab === 'BEAT_GILTI_FDII'" [class.disabled]="beatGiltiTabDisabled">
        <a (click)="!beatGiltiTabDisabled && (activeTab = 'BEAT_GILTI_FDII')" style="cursor: pointer;" class="btn-sm">BEAT/GILTI/FDII</a>
      </li>
    </ul>

    <div class="tab-content">

      <!-- TI / Other Info Tab -->
      @if (activeTab === 'TI') {
<div class="tab-pane active">

        <!-- Small loader -->
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}

        @if (!showFormLoader) {
<div>
          <div align="center" class="table-top">
            <table border="0" style="width:100%;">
              @for (row of k1caplibFormData; track $index) {
<tr [style.display]="row.LINE_NO === 'NK1EST' ? '' : 'none'">
                @if (row.IS_DISPLAY === 'Y') {
<td align="right">
                  <b>{{row.DESCRIPTION}}</b>&nbsp;&nbsp;
                  <input type="checkbox"
                         [checked]="row.ATTRIB_VALUE === '1'"
                         (change)="row.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
                </td>
}
              </tr>
}
            </table>
          </div>

          <div align="center" class="table-scroll">
            <table class="table table-bordered form-inline custom-table" role="grid" style="width:100%;">
              <thead style="border-top:0px">
                <tr>
                  <th width="8%"><span>&nbsp;&nbsp;&nbsp;&nbsp;Line #</span></th>
                  <th width="75%">Description</th>
                  <th></th>
                </tr>
              </thead>
              <tbody style="border-top:0px">

                <!-- Part II Header -->
                @for (row of partHeaderIIFormData; track $index) {
<tr>
                  <td colspan="3"><h4><b><font color="#00008b">{{row.DESCRIPTION}}</font></b></h4></td>
                </tr>
}

                <!-- K1CAPLIB Section Header -->
                @for (row of k1caplibFormData; track $index) {

                  @if (row.LINE_NO === 'N/A' && row.IS_DISPLAY === 'Y' && row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'SH') {
<tr [class.shown]="showK1Caplib">
                    <td width="2%" class="details-control" (click)="showHideSection('k1caplib')" style="cursor:pointer; text-align:center; vertical-align:middle;">
                      <i class="fa" [ngClass]="showK1Caplib ? 'fa-minus-circle color-red' : 'fa-plus-circle color-green'"></i>
                    </td>
                    <td [attr.colspan]="colspan" style="background-color: #778899"><b><font color="white">{{row.DESCRIPTION}}</font></b></td>
                  </tr>
}
                
}

                <!-- K1CAPLIB Data Rows -->
                @for (row of k1caplibFormData; track $index) {

                  @if (row.LINE_NO !== 'N/A' && showK1Caplib && row.IS_DISPLAY === 'Y') {
<tr>
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"><h4><b><font color="#808080">{{row.DISPLAY_LINE_NO}}</font></b></h4></td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"></td>
}
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"><b>{{row.DISPLAY_LINE_NO}}</b></td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"></td>
}
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td align="center" width="2%">{{row.DISPLAY_LINE_NO}}</td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td align="center" width="2%"></td>
}

                    @if (row.ROW_TYPE === 'LH') {
<td width="38%"><h4><b><font color="#808080">{{row.DESCRIPTION}}</font></b></h4></td>
}
                    @if (row.ROW_TYPE === 'AGG') {
<td width="38%"><b>{{row.DESCRIPTION}}</b></td>
}
                    @if (row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td width="38%">{{row.DESCRIPTION}}</td>
}

                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '11' && row.LINE_NO !== 'NK1EST') {
<td width="10%" align="right">
                      <input type="checkbox" [checked]="row.ATTRIB_VALUE === '1'" (change)="row.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
                    </td>
}
                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '12' && row.SUB_FORM != null) {
<td width="10%" align="right">
                      <select class="form-control" [ngModel]="row.ATTRIB_VALUE" [compareWith]="compareDropdownObj" [ngModelOptions]="{standalone: true}" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)">
                        @for (s of displayDropDownList(row.FORM_LINE_KEY, row.SUB_FORM); track $index) {
<option [ngValue]="s">{{s.name}}</option>
}
                      </select>
                    </td>
}
                    @if (row.ROW_TYPE === 'DT') {
<td width="10%" align="right">
                      <input [(ngModel)]="row.ATTRIB_VALUE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="applyFormulaMain(row)"/>
                    </td>
}
                    @if (row.ROW_TYPE === 'LH') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                      <h4><b>{{formatNumber(row.ATTRIB_VALUE)}}</b></h4>
                    </td>
}
                    @if (row.ROW_TYPE === 'AGG') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                      <b>{{formatNumber(row.ATTRIB_VALUE)}}</b>
                    </td>
}
                    @if (row.ROW_TYPE === 'DTA') {
<td width="10%" align="right">
                      <textarea [ngModel]="row.ATTRIB_VALUE" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)" type="text" class="form-control input-xxlarge" style="width:100%"></textarea>
                    </td>
}
                  </tr>
}
                
}

                <!-- Part III Header -->
                @for (row of partHeaderIIIFormData; track $index) {
<tr>
                  <td colspan="3"><h4><b><font color="00008b">{{row.DESCRIPTION}}</font></b></h4></td>
                </tr>
}

                <!-- TI Section -->
                @for (row of tiFormData; track $index) {

                  @if (row.LINE_NO === 'N/A' && row.IS_DISPLAY === 'Y' && row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'SH') {
<tr [class.shown]="showTI">
                    <td width="2%" class="details-control" (click)="showHideSection('ti')" style="cursor:pointer; text-align:center; vertical-align:middle;">
                      <i class="fa" [ngClass]="showTI ? 'fa-minus-circle color-red' : 'fa-plus-circle color-green'"></i>
                    </td>
                    <td [attr.colspan]="colspan" style="background-color: #778899"><b><font color="white">{{row.DESCRIPTION}}</font></b></td>
                  </tr>
}
                
}
                @for (row of tiFormData; track $index) {

                  @if (row.LINE_NO !== 'N/A' && showTI && row.IS_DISPLAY === 'Y') {
<tr>
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"><h4><b><font color="#808080">{{row.DISPLAY_LINE_NO}}</font></b></h4></td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"></td>
}
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"><b>{{row.DISPLAY_LINE_NO}}</b></td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"></td>
}
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td align="center" width="2%">{{row.DISPLAY_LINE_NO}}</td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td align="center" width="2%"></td>
}

                    @if (row.ROW_TYPE === 'LH') {
<td width="38%"><h4><b><font color="#808080">{{row.DESCRIPTION}}</font></b></h4></td>
}
                    @if (row.ROW_TYPE === 'AGG') {
<td width="38%"><b>{{row.DESCRIPTION}}</b></td>
}
                    @if (row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td width="38%">{{row.DESCRIPTION}}</td>
}

                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '11') {
<td width="10%" align="right">
                      <input type="checkbox" [checked]="row.ATTRIB_VALUE === '1'" (change)="row.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
                    </td>
}
                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '12' && row.SUB_FORM != null) {
<td width="10%" align="right">
                      <select class="form-control" [ngModel]="row.ATTRIB_VALUE" [compareWith]="compareDropdownObj" [ngModelOptions]="{standalone: true}" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)">
                        @for (s of displayDropDownList(row.FORM_LINE_KEY, row.SUB_FORM); track $index) {
<option [ngValue]="s">{{s.name}}</option>
}
                      </select>
                    </td>
}
                    @if (row.ROW_TYPE === 'DT') {
<td width="10%" align="right">
                      <input [(ngModel)]="row.ATTRIB_VALUE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="applyFormulaMain(row)"/>
                    </td>
}
                    @if (row.ROW_TYPE === 'LH') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                      <h4><b>{{formatNumber(row.ATTRIB_VALUE)}}</b></h4>
                    </td>
}
                    @if (row.ROW_TYPE === 'AGG') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                      <b>{{formatNumber(row.ATTRIB_VALUE)}}</b>
                    </td>
}
                    @if (row.ROW_TYPE === 'DTA') {
<td width="10%" align="right">
                      <textarea [ngModel]="row.ATTRIB_VALUE" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)" type="text" class="form-control input-xxlarge" style="width:100%"></textarea>
                    </td>
}
                  </tr>
}
                
}

                <!-- CREDIT Section -->
                @for (row of creditFormData; track $index) {

                  @if (row.LINE_NO === 'N/A' && row.IS_DISPLAY === 'Y' && row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'SH') {
<tr [class.shown]="showCredits">
                    <td width="2%" class="details-control" (click)="showHideSection('credits')" style="cursor:pointer; text-align:center; vertical-align:middle;">
                      <i class="fa" [ngClass]="showCredits ? 'fa-minus-circle color-red' : 'fa-plus-circle color-green'"></i>
                    </td>
                    <td [attr.colspan]="colspan" style="background-color: #778899"><b><font color="white">{{row.DESCRIPTION}}</font></b></td>
                  </tr>
}
                
}
                @for (row of creditFormData; track $index) {

                  @if (row.LINE_NO !== 'N/A' && showCredits && row.IS_DISPLAY === 'Y') {
<tr>
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"><h4><b><font color="#808080">{{row.DISPLAY_LINE_NO}}</font></b></h4></td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"></td>
}
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"><b>{{row.DISPLAY_LINE_NO}}</b></td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"></td>
}
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td align="center" width="2%">{{row.DISPLAY_LINE_NO}}</td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td align="center" width="2%"></td>
}

                    @if (row.ROW_TYPE === 'LH') {
<td width="38%"><h4><b><font color="#808080">{{row.DESCRIPTION}}</font></b></h4></td>
}
                    @if (row.ROW_TYPE === 'AGG') {
<td width="38%"><b>{{row.DESCRIPTION}}</b></td>
}
                    @if (row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td width="38%">{{row.DESCRIPTION}}</td>
}

                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '11') {
<td width="10%" align="right">
                      <input type="checkbox" [checked]="row.ATTRIB_VALUE === '1'" (change)="row.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
                    </td>
}
                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '12' && row.SUB_FORM != null) {
<td width="10%" align="right">
                      <select class="form-control" [ngModel]="row.ATTRIB_VALUE" [compareWith]="compareDropdownObj" [ngModelOptions]="{standalone: true}" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)">
                        @for (s of displayDropDownList(row.FORM_LINE_KEY, row.SUB_FORM); track $index) {
<option [ngValue]="s">{{s.name}}</option>
}
                      </select>
                    </td>
}
                    @if (row.ROW_TYPE === 'DT') {
<td width="10%" align="right">
                      <input [(ngModel)]="row.ATTRIB_VALUE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="applyFormulaMain(row)"/>
                    </td>
}
                    @if (row.ROW_TYPE === 'LH') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                      <h4><b>{{formatNumber(row.ATTRIB_VALUE)}}</b></h4>
                    </td>
}
                    @if (row.ROW_TYPE === 'AGG') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                      <b>{{formatNumber(row.ATTRIB_VALUE)}}</b>
                    </td>
}
                    @if (row.ROW_TYPE === 'DTA') {
<td width="10%" align="right">
                      <textarea [ngModel]="row.ATTRIB_VALUE" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)" type="text" class="form-control input-xxlarge" style="width:100%"></textarea>
                    </td>
}
                  </tr>
}
                
}

                <!-- AMTACE Section -->
                @for (row of amtaceFormData; track $index) {

                  @if (row.LINE_NO === 'N/A' && row.IS_DISPLAY === 'Y' && row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'SH') {
<tr [class.shown]="showAMTACE">
                    <td width="2%" class="details-control" (click)="showHideSection('amtace')" style="cursor:pointer; text-align:center; vertical-align:middle;">
                      <i class="fa" [ngClass]="showAMTACE ? 'fa-minus-circle color-red' : 'fa-plus-circle color-green'"></i>
                    </td>
                    <td [attr.colspan]="colspan" style="background-color: #778899"><b><font color="white">{{row.DESCRIPTION}}</font></b></td>
                  </tr>
}
                
}
                @for (row of amtaceFormData; track $index) {

                  @if (row.LINE_NO !== 'N/A' && showAMTACE && row.IS_DISPLAY === 'Y') {
<tr>
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"><h4><b><font color="#808080">{{row.DISPLAY_LINE_NO}}</font></b></h4></td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"></td>
}
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"><b>{{row.DISPLAY_LINE_NO}}</b></td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"></td>
}
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td align="center" width="2%">{{row.DISPLAY_LINE_NO}}</td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td align="center" width="2%"></td>
}

                    @if (row.ROW_TYPE === 'LH') {
<td width="38%"><h4><b><font color="#808080">{{row.DESCRIPTION}}</font></b></h4></td>
}
                    @if (row.ROW_TYPE === 'AGG') {
<td width="38%"><b>{{row.DESCRIPTION}}</b></td>
}
                    @if (row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td width="38%">{{row.DESCRIPTION}}</td>
}

                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '11') {
<td width="10%" align="right">
                      <input type="checkbox" [checked]="row.ATTRIB_VALUE === '1'" (change)="row.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
                    </td>
}
                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '12' && row.SUB_FORM != null) {
<td width="10%" align="right">
                      <select class="form-control" [ngModel]="row.ATTRIB_VALUE" [compareWith]="compareDropdownObj" [ngModelOptions]="{standalone: true}" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)">
                        @for (s of displayDropDownList(row.FORM_LINE_KEY, row.SUB_FORM); track $index) {
<option [ngValue]="s">{{s.name}}</option>
}
                      </select>
                    </td>
}
                    @if (row.ROW_TYPE === 'DT') {
<td width="10%" align="right">
                      <input [(ngModel)]="row.ATTRIB_VALUE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="applyFormulaMain(row)"/>
                    </td>
}
                    @if (row.ROW_TYPE === 'LH') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                      <h4><b>{{formatNumber(row.ATTRIB_VALUE)}}</b></h4>
                    </td>
}
                    @if (row.ROW_TYPE === 'AGG') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                      <b>{{formatNumber(row.ATTRIB_VALUE)}}</b>
                    </td>
}
                    @if (row.ROW_TYPE === 'DTA') {
<td width="10%" align="right">
                      <textarea [ngModel]="row.ATTRIB_VALUE" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)" type="text" class="form-control input-xxlarge" style="width:100%"></textarea>
                    </td>
}
                  </tr>
}
                
}

                <!-- OTHER Section -->
                @for (row of otherFormData; track $index) {

                  @if (row.LINE_NO === 'N/A' && row.IS_DISPLAY === 'Y' && row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'SH') {
<tr [class.shown]="showOTHER">
                    <td width="2%" class="details-control" (click)="showHideSection('other')" style="cursor:pointer; text-align:center; vertical-align:middle;">
                      <i class="fa" [ngClass]="showOTHER ? 'fa-minus-circle color-red' : 'fa-plus-circle color-green'"></i>
                    </td>
                    <td [attr.colspan]="colspan" style="background-color: #778899"><b><font color="white">{{row.DESCRIPTION}}</font></b></td>
                  </tr>
}
                
}
                @for (row of otherFormData; track $index) {

                  @if (row.LINE_NO !== 'N/A' && showOTHER && row.IS_DISPLAY === 'Y') {
<tr>
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"><h4><b><font color="#808080">{{row.DISPLAY_LINE_NO}}</font></b></h4></td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"></td>
}
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"><b>{{row.DISPLAY_LINE_NO}}</b></td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"></td>
}
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td align="center" width="2%">{{row.DISPLAY_LINE_NO}}</td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td align="center" width="2%"></td>
}

                    @if (row.ROW_TYPE === 'LH') {
<td width="38%"><h4><b><font color="#808080">{{row.DESCRIPTION}}</font></b></h4></td>
}
                    @if (row.ROW_TYPE === 'AGG') {
<td width="38%"><b>{{row.DESCRIPTION}}</b></td>
}
                    @if (row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td width="38%">{{row.DESCRIPTION}}</td>
}

                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '11') {
<td width="10%" align="right">
                      <input type="checkbox" [checked]="row.ATTRIB_VALUE === '1'" (change)="row.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
                    </td>
}
                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '12' && row.SUB_FORM != null) {
<td width="10%" align="right">
                      <select class="form-control" [ngModel]="row.ATTRIB_VALUE" [compareWith]="compareDropdownObj" [ngModelOptions]="{standalone: true}" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)">
                        @for (s of displayDropDownList(row.FORM_LINE_KEY, row.SUB_FORM); track $index) {
<option [ngValue]="s">{{s.name}}</option>
}
                      </select>
                    </td>
}
                    @if (row.ROW_TYPE === 'DT') {
<td width="10%" align="right">
                      <input [(ngModel)]="row.ATTRIB_VALUE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="applyFormulaMain(row)"/>
                    </td>
}
                    @if (row.ROW_TYPE === 'LH') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                      <h4><b>{{formatNumber(row.ATTRIB_VALUE)}}</b></h4>
                    </td>
}
                    @if (row.ROW_TYPE === 'AGG') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                      <b>{{formatNumber(row.ATTRIB_VALUE)}}</b>
                    </td>
}
                    @if (row.ROW_TYPE === 'DTA') {
<td width="10%" align="right">
                      <textarea [ngModel]="row.ATTRIB_VALUE" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)" type="text" class="form-control input-xxlarge" style="width:100%"></textarea>
                    </td>
}
                  </tr>
}
                
}

                <!-- TAXCAPITAL Section -->
                @for (row of taxcapitalFormData; track $index) {

                  @if (row.LINE_NO === 'N/A' && row.IS_DISPLAY === 'Y' && row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'SH') {
<tr [class.shown]="showTAXCAPITAL">
                    <td width="2%" class="details-control" (click)="showHideSection('taxcapital')" style="cursor:pointer; text-align:center; vertical-align:middle;">
                      <i class="fa" [ngClass]="showTAXCAPITAL ? 'fa-minus-circle color-red' : 'fa-plus-circle color-green'"></i>
                    </td>
                    <td [attr.colspan]="colspan" style="background-color: #778899"><b><font color="white">{{row.DESCRIPTION}}</font></b></td>
                  </tr>
}
                
}
                @for (row of taxcapitalFormData; track $index) {

                  @if (row.LINE_NO !== 'N/A' && showTAXCAPITAL && row.IS_DISPLAY === 'Y') {
<tr>
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"><h4><b><font color="#808080">{{row.DISPLAY_LINE_NO}}</font></b></h4></td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"></td>
}
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"><b>{{row.DISPLAY_LINE_NO}}</b></td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"></td>
}
                    @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td align="center" width="2%">{{row.LINE_NO}}</td>
}
                    @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td align="center" width="2%"></td>
}

                    @if (row.ROW_TYPE === 'LH') {
<td width="38%"><h4><b><font color="#808080">{{row.DESCRIPTION}}</font></b></h4></td>
}
                    @if (row.ROW_TYPE === 'AGG') {
<td width="38%"><b>{{row.DESCRIPTION}}</b></td>
}
                    @if (row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td width="38%">{{row.DESCRIPTION}}</td>
}

                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '11') {
<td width="10%" align="right">
                      <input type="checkbox" [checked]="row.ATTRIB_VALUE === '1'" (change)="row.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
                    </td>
}
                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '12' && row.SUB_FORM != null) {
<td width="10%" align="right">
                      <select class="form-control" [ngModel]="row.ATTRIB_VALUE" [compareWith]="compareDropdownObj" [ngModelOptions]="{standalone: true}" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)">
                        @for (s of displayDropDownList(row.FORM_LINE_KEY, row.SUB_FORM); track $index) {
<option [ngValue]="s">{{s.name}}</option>
}
                      </select>
                    </td>
}
                    @if (row.ROW_TYPE === 'DT') {
<td width="10%" align="right">
                      <input [(ngModel)]="row.ATTRIB_VALUE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="applyFormulaMain(row)"/>
                    </td>
}
                    @if (row.ROW_TYPE === 'LH') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                      <h4><b>{{formatNumber(row.ATTRIB_VALUE)}}</b></h4>
                    </td>
}
                    @if (row.ROW_TYPE === 'AGG') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                      <b>{{formatNumber(row.ATTRIB_VALUE)}}</b>
                    </td>
}
                    @if (row.ROW_TYPE === 'DTA') {
<td width="10%" align="right">
                      <textarea [ngModel]="row.ATTRIB_VALUE" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)" type="text" class="form-control input-xxlarge" style="width:100%"></textarea>
                    </td>
}
                  </tr>
}
                
}

              </tbody>
            </table>
          </div>
        </div>
}
      </div>
}

      <!-- FTC Tab -->
      @if (activeTab === 'FTC') {
<div class="tab-pane active">

        <!-- Country Add Control -->
        <table style="width:28%;" align="center">
          <tr>
            <td>
              <select #selectedCountryModel class="form-control">
                <option value="">-- Select Country --</option>
                @for (country of countryList; track $index) {
<option [value]="country.CODE_KEY + '|' + country.CODE_DESCRIPTION">{{country.CODE_DESCRIPTION}}</option>
}
              </select>
            </td>
            <td>&nbsp;&nbsp;</td>
            <td>
              <button class="btn btn-success btn-sm" type="button"
                      (click)="addCountryColumn(selectedCountryModel.value.split('|')[0], selectedCountryModel.value.split('|')[1])">
                Add Country
              </button>
            </td>
          </tr>
        </table>

        <div align="center" class="table-scroll-fsi">
          <table style="table-layout: fixed;" class="table table-bordered form-inline custom-table" role="grid">
            <thead>
              <tr>
                <th style="width:100px"><span>&nbsp;&nbsp;&nbsp;&nbsp;Line #</span></th>
                <th style="width:510px">Description</th>
                @for (val of partHeaderIIIFSIFormData; track $index) {
<th style="width:170px"></th>
}
                @for (val of partHeaderDynamic; track $index; let idx = $index) {
<th style="width:170px">
                  <table style="border:none;">
                    <tr>
                      <td width="70%" align="center" style="border:none;">{{val.ATTRIB_VALUE}}</td>
                      <td style="border:none;">
                        <i class="fa fa-minus-circle fa-lg pull-right"
                           style="cursor: pointer; margin-top: 4px;"
                           title="Remove Country"
                           (click)="removeCountryColumn(idx)">
                        </i>
                      </td>
                    </tr>
                  </table>
                </th>
}
              </tr>
            </thead>
            <tbody>
              <!-- Part III Header -->
              @for (row of partHeaderIIIFormData; track $index) {
<tr>
                <td [attr.colspan]="colspan + 1"><h4><b><font color="00008b">{{row.DESCRIPTION}}</font></b></h4></td>
              </tr>
}

              <!-- FSI Section Header -->
              @for (row of fsiFormData; track $index) {

                @if (row.LINE_NO === 'N/A' && row.IS_DISPLAY === 'Y' && row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'SH') {
<tr [class.shown]="showFSI">
                  <td width="2%" class="details-control" (click)="showHideSection('fsi')" style="cursor:pointer; text-align:center; vertical-align:middle;">
                    <i class="fa" [ngClass]="showFSI ? 'fa-minus-circle color-red' : 'fa-plus-circle color-green'"></i>
                  </td>
                  <td [attr.colspan]="colspan" style="background-color: #778899"><b><font color="white">{{row.DESCRIPTION}}</font></b></td>
                </tr>
}
              
}

              <!-- FSI Data Rows -->
              @for (row of fsiFormData; track $index) {

                @if (row.LINE_NO !== 'N/A' && showFSI && row.IS_DISPLAY === 'Y') {
<tr>
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'LH') {
<td align="center"><h4><b><font color="#808080">{{row.LINE_NO}}</font></b></h4></td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'LH') {
<td align="center"></td>
}
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'AGG') {
<td align="center"><b>{{row.LINE_NO}}</b></td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'AGG') {
<td align="center"></td>
}
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td align="center">{{row.LINE_NO}}</td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td align="center"></td>
}

                  @if (row.ROW_TYPE === 'LH') {
<td width="510px"><h4><b><font color="#808080">{{row.DESCRIPTION}}</font></b></h4></td>
}
                  @if (row.ROW_TYPE === 'AGG') {
<td width="510px"><b>{{row.DESCRIPTION}}</b></td>
}
                  @if (row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG') {
<td width="510px">{{row.DESCRIPTION}}</td>
}

                  <!-- Dynamic country columns -->
                  @if (row.DYNAMIC_COUNTRY) {

                    <!-- Checkbox CONS -->
                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '11' && row.COL_ID === 'CONS') {

                      @for (val of row.DYNAMIC_COUNTRY; track $index; let idx = $index) {
<td width="10%" align="right">
                        @if (idx === 0) {
<input type="checkbox" [checked]="val.ATTRIB_VALUE === '1'" (change)="val.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
}
                        @if (idx > 0) {
<label></label>
}
                      </td>
}
                    
}
                    <!-- Checkbox non-CONS -->
                    @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '11' && row.COL_ID !== 'CONS') {

                      @for (val of row.DYNAMIC_COUNTRY; track $index; let idx = $index) {
<td width="10%" align="right">
                        @if (idx === 0) {
<label></label>
}
                        @if (idx > 0) {
<input type="checkbox" [checked]="val.ATTRIB_VALUE === '1'" (change)="val.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
}
                      </td>
}
                    
}
                    <!-- Editable DT CONS -->
                    @if (row.ROW_TYPE === 'DT' && row.COL_ID === 'CONS') {

                      @for (val of row.DYNAMIC_COUNTRY; track $index; let idx = $index) {
<td width="10%" align="right">
                        @if (idx === 0) {
<input [(ngModel)]="val.ATTRIB_VALUE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="applyFormulaFSI(row, idx)"/>
}
                        @if (idx > 0) {
<label></label>
}
                      </td>
}
                    
}
                    <!-- Editable DT non-CONS -->
                    @if (row.ROW_TYPE === 'DT' && row.COL_ID !== 'CONS') {

                      @for (val of row.DYNAMIC_COUNTRY; track $index; let idx = $index) {
<td width="10%" align="right">
                        @if (idx === 0) {
<label></label>
}
                        @if (idx > 0) {
<input [(ngModel)]="val.ATTRIB_VALUE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="applyFormulaFSI(row, idx)"/>
}
                      </td>
}
                    
}
                    <!-- Label LH CONS -->
                    @if (row.ROW_TYPE === 'LH' && row.COL_ID === 'CONS') {

                      @for (val of row.DYNAMIC_COUNTRY; track $index; let idx = $index) {
<td width="10%" align="right" [class.color-red]="val.ATTRIB_VALUE < 0">
                        @if (idx === 0) {
<h4><b>{{formatNumber(val.ATTRIB_VALUE)}}</b></h4>
}
                        @if (idx > 0) {
<label></label>
}
                      </td>
}
                    
}
                    <!-- Label LH non-CONS -->
                    @if (row.ROW_TYPE === 'LH' && row.COL_ID !== 'CONS') {

                      @for (val of row.DYNAMIC_COUNTRY; track $index; let idx = $index) {
<td width="10%" align="right" [class.color-red]="val.ATTRIB_VALUE < 0">
                        @if (idx === 0) {
<label></label>
}
                        @if (idx > 0) {
<h4><b>{{formatNumber(val.ATTRIB_VALUE)}}</b></h4>
}
                      </td>
}
                    
}
                    <!-- AGG CONS -->
                    @if (row.ROW_TYPE === 'AGG' && row.COL_ID === 'CONS') {

                      @for (val of row.DYNAMIC_COUNTRY; track $index; let idx = $index) {
<td width="10%" align="right" [class.color-red]="val.ATTRIB_VALUE < 0">
                        @if (idx === 0) {
<b>{{formatNumber(val.ATTRIB_VALUE)}}</b>
}
                        @if (idx > 0) {
<label></label>
}
                      </td>
}
                    
}
                    <!-- AGG non-CONS -->
                    @if (row.ROW_TYPE === 'AGG' && row.COL_ID !== 'CONS') {

                      @for (val of row.DYNAMIC_COUNTRY; track $index; let idx = $index) {
<td width="10%" align="right" [class.color-red]="val.ATTRIB_VALUE < 0">
                        @if (idx === 0) {
<label></label>
}
                        @if (idx > 0) {
<b>{{formatNumber(val.ATTRIB_VALUE)}}</b>
}
                      </td>
}
                    
}
                    <!-- DTA CONS -->
                    @if (row.ROW_TYPE === 'DTA' && row.COL_ID === 'CONS') {

                      @for (val of row.DYNAMIC_COUNTRY; track $index; let idx = $index) {
<td width="10%" align="right">
                        @if (idx === 0) {
<textarea [ngModel]="val.ATTRIB_VALUE" (ngModelChange)="val.ATTRIB_VALUE = $event; setChange(row)" type="text" class="form-control input-xxlarge" style="width:100%"></textarea>
}
                        @if (idx > 0) {
<label></label>
}
                      </td>
}
                    
}
                    <!-- DTA non-CONS -->
                    @if (row.ROW_TYPE === 'DTA' && row.COL_ID !== 'CONS') {

                      @for (val of row.DYNAMIC_COUNTRY; track $index; let idx = $index) {
<td width="10%" align="right">
                        @if (idx === 0) {
<label></label>
}
                        @if (idx > 0) {
<textarea [ngModel]="val.ATTRIB_VALUE" (ngModelChange)="val.ATTRIB_VALUE = $event; setChange(row)" type="text" class="form-control input-xxlarge" style="width:100%"></textarea>
}
                      </td>
}
                    
}
                  
}
                </tr>
}
              
}
            </tbody>
          </table>
        </div>
      </div>
}

      <!-- FTC - Gross Income Detail Tab -->
      @if (activeTab === 'FSI_GI') {
<div class="tab-pane active">

        <table class="table form-inline" style="width:90%; border-top:0px" align="center">
          <tr>
            <td style="border-top-width:0px !important;">
              <table style="width:20%;" align="left">
                <tr>
                  <td style="font-size: medium; font-weight: bolder;">Country&nbsp;&nbsp;</td>
                  <td>
                    <select [ngModel]="mySelectedCountry.COUNTRY_DESCRIPTION"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="showSelectedCountry($event)"
                            class="form-control input-sm">
                      @for (country of myCountryList; track $index) {
<option [value]="country.COUNTRY_DESCRIPTION">{{country.COUNTRY_DESCRIPTION}}</option>
}
                    </select>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <table class="table table-no-border form-inline" style="width:90%" align="center">
          <thead>
            <tr>
              <td width="50%"></td>
              <td width="10%" style="text-align: center; font-size: medium; font-weight: bolder"><u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;General&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u></td>
              <td width="10%" style="text-align: center; font-size: medium; font-weight: bolder"><u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Branch&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u></td>
              <td width="10%" style="text-align: center; font-size: medium; font-weight: bolder"><u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Passive&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u></td>
              <td width="10%" style="text-align: center; font-size: medium; font-weight: bolder"><u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Treaty&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u></td>
              <td width="10%" style="text-align: center; font-size: medium; font-weight: bolder"><u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;901j&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u></td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td width="50%" style="border-top-width:0px !important; font-size: medium; color:#00008b"><b>Per Line 16 </b>(<i>E-H2 on FTC Tab</i>)</td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="general_amt_fsi < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(general_amt_fsi)}}</label></td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="branch_amt_fsi < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(branch_amt_fsi)}}</label></td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="passive_amt_fsi < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(passive_amt_fsi)}}</label></td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="treaty_amt_fsi < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(treaty_amt_fsi)}}</label></td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="sec901j_amt_fsi < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(sec901j_amt_fsi)}}</label></td>
            </tr>
            <tr>
              <td width="50%" style="border-top-width:0px !important; font-size: medium; font-weight: bolder; color:#00008b">Per Gross Income Split Below</td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="general_amt_total < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(general_amt_total)}}</label></td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="branch_amt_total < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(branch_amt_total)}}</label></td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="passive_amt_total < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(passive_amt_total)}}</label></td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="treaty_amt_total < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(treaty_amt_total)}}</label></td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="sec901j_amt_total < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(sec901j_amt_total)}}</label></td>
            </tr>
            <tr>
              <td width="50%" style="border-top-width:0px !important; font-size: medium; font-weight: normal; color:#00008b">Variance</td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="general_amt_var < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(general_amt_var)}}</label></td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="branch_amt_var < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(branch_amt_var)}}</label></td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="passive_amt_var < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(passive_amt_var)}}</label></td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="treaty_amt_var < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(treaty_amt_var)}}</label></td>
              <td style="text-align: right; border-top-width:0px !important;" [class.color-red]="sec901j_amt_var < 0"><label style="border:0px; padding-right: 12px !important;">{{formatNumber(sec901j_amt_var)}}</label></td>
            </tr>
          </tbody>
        </table>

        <div align="center" class="table-scroll-fsi-sourcing">
          <table style="table-layout: fixed;width:90%" class="table table-no-border form-inline custom-table">
            <thead>
              <tr>
                <th width="14%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;">Gross Income Type</th>
                <th width="12%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;">Taxable Income Schedule K Line Item</th>
                <th width="12%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;">Amount Per Schedule K</th>
                <th width="12%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;">Amount Available to be Sourced</th>
                <th width="10%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;">General</th>
                <th width="10%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;">Branch</th>
                <th width="10%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;">Passive</th>
                <th width="10%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;">Treaty</th>
                <th width="10%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;">901j</th>
              </tr>
            </thead>
            <tbody>
              @for (row of selectedBasketData; track $index) {
<tr>
                <td width="14%" style="text-align: left; vertical-align: text-top; border-top-width:0px !important; font-size: medium; font-weight: bolder; color:#00008b">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{row.ACCT_DESC}}</td>
                <td width="12%" style="text-align: right; vertical-align: text-top; border-top-width:0px !important;"><label style="border:0px; padding-right: 12px !important;"></label></td>
                <td width="12%" style="text-align: right; vertical-align: text-top; border-top-width:0px !important;" [class.color-red]="getTISumByFLCCodeGrouping(row.FLC_CODE) < 0"><label style="border:0px; padding-right: 30px !important;">{{formatNumber(getTISumByFLCCodeGrouping(row.FLC_CODE))}}</label></td>
                <td width="12%" style="text-align: right; vertical-align: text-top; border-top-width:0px !important;" [class.color-red]="(getTISumByFLCCodeGrouping(row.FLC_CODE) - getBasketSumByFLCCodeGrouping(row.FLC_CODE)) < 0"><label style="border:0px; padding-right: 30px !important;">{{formatNumber(getTISumByFLCCodeGrouping(row.FLC_CODE) - getBasketSumByFLCCodeGrouping(row.FLC_CODE))}}</label></td>
                <td width="10%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;"><input [(ngModel)]="row.GENLIM" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="recalcGeneral(row)"/></td>
                <td width="10%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;"><input [(ngModel)]="row.BRANCH" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="recalcBranch(row)"/></td>
                <td width="10%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;"><input [(ngModel)]="row.PASSIVE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="recalcPassive(row)"/></td>
                <td width="10%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;"><input [(ngModel)]="row.TREATY" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="recalcTreaty(row)"/></td>
                <td width="10%" style="text-align: center; vertical-align: text-top; border-top-width:0px !important;"><input [(ngModel)]="row.SEC901J" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="recalcSec901j(row)"/></td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
}

      <!-- BEAT/GILTI/FDII Tab -->
      @if (activeTab === 'BEAT_GILTI_FDII') {
<div class="tab-pane active">

        <div align="center" class="table-scroll">
          <table class="table table-bordered form-inline custom-table" role="grid" style="width:100%;">
            <thead style="border-top:0px">
              <tr>
                <th width="8%"><span>&nbsp;&nbsp;&nbsp;&nbsp;Line #</span></th>
                <th width="35%">Description</th>
                <th></th>
              </tr>
            </thead>
            <tbody style="border-top:0px">

              <!-- BEAT Section -->
              @for (row of beatData; track $index) {

                @if (row.LINE_NO === 'N/A' && row.IS_DISPLAY === 'Y' && row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'SH') {
<tr>
                  <td width="2%" style="background-color: #778899"></td>
                  <td [attr.colspan]="colspan" style="background-color: #778899"><b><font color="white">{{row.DESCRIPTION}}</font></b></td>
                </tr>
}
              
}
              @for (row of beatData; track $index) {

                @if (row.LINE_NO !== 'N/A' && row.IS_DISPLAY === 'Y') {
<tr>
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"><h4><b><font color="#808080">{{row.DISPLAY_LINE_NO}}</font></b></h4></td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"></td>
}
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"><b>{{row.DISPLAY_LINE_NO}}</b></td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"></td>
}
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td align="center" width="2%">{{row.DISPLAY_LINE_NO}}</td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td align="center" width="2%"></td>
}

                  @if (row.ROW_TYPE === 'LH') {
<td width="45%"><h4><b><font color="#808080">{{row.DESCRIPTION}}</font></b></h4></td>
}
                  @if (row.ROW_TYPE === 'AGG') {
<td width="45%"><b>{{row.DESCRIPTION}}</b></td>
}
                  @if (row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td width="45%">{{row.DESCRIPTION}}</td>
}

                  @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '11' && row.LINE_NO !== 'NK1EST') {
<td width="10%" align="right">
                    <input type="checkbox" [checked]="row.ATTRIB_VALUE === '1'" (change)="row.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
                  </td>
}
                  @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '12' && row.SUB_FORM != null) {
<td width="10%" align="right">
                    <select class="form-control" [ngModel]="row.ATTRIB_VALUE" [compareWith]="compareDropdownObj" [ngModelOptions]="{standalone: true}" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)">
                      @for (s of displayDropDownList(row.FORM_LINE_KEY, row.SUB_FORM); track $index) {
<option [ngValue]="s">{{s.name}}</option>
}
                    </select>
                  </td>
}
                  @if (row.ROW_TYPE === 'DT') {
<td width="10%" align="right">
                    <input [(ngModel)]="row.ATTRIB_VALUE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="setChange(row)"/>
                  </td>
}
                  @if (row.ROW_TYPE === 'LH') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                    <h4><b>{{formatNumber(row.ATTRIB_VALUE)}}</b></h4>
                  </td>
}
                  @if (row.ROW_TYPE === 'AGG') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                    <b>{{formatNumber(row.ATTRIB_VALUE)}}</b>
                  </td>
}
                  @if (row.ROW_TYPE === 'DTA') {
<td width="10%" align="right">
                    <textarea [ngModel]="row.ATTRIB_VALUE" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)" type="text" class="form-control input-xxlarge" style="width:100%"></textarea>
                  </td>
}
                </tr>
}
              
}

              <!-- GILTI Section -->
              @for (row of giltiData; track $index) {

                @if (row.LINE_NO === 'N/A' && row.IS_DISPLAY === 'Y' && row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'SH') {
<tr>
                  <td width="2%" style="background-color: #778899"></td>
                  <td [attr.colspan]="colspan" style="background-color: #778899"><b><font color="white">{{row.DESCRIPTION}}</font></b></td>
                </tr>
}
              
}
              @for (row of giltiData; track $index) {

                @if (row.LINE_NO !== 'N/A' && row.IS_DISPLAY === 'Y') {
<tr>
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"><h4><b><font color="#808080">{{row.DISPLAY_LINE_NO}}</font></b></h4></td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"></td>
}
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"><b>{{row.DISPLAY_LINE_NO}}</b></td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"></td>
}
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td align="center" width="2%">{{row.DISPLAY_LINE_NO}}</td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td align="center" width="2%"></td>
}

                  @if (row.ROW_TYPE === 'LH') {
<td width="45%"><h4><b><font color="#808080">{{row.DESCRIPTION}}</font></b></h4></td>
}
                  @if (row.ROW_TYPE === 'AGG') {
<td width="45%"><b>{{row.DESCRIPTION}}</b></td>
}
                  @if (row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td width="45%">{{row.DESCRIPTION}}</td>
}

                  @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '11' && row.LINE_NO !== 'NK1EST') {
<td width="10%" align="right">
                    <input type="checkbox" [checked]="row.ATTRIB_VALUE === '1'" (change)="row.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
                  </td>
}
                  @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '12' && row.SUB_FORM != null) {
<td width="10%" align="right">
                    <select class="form-control" [ngModel]="row.ATTRIB_VALUE" [compareWith]="compareDropdownObj" [ngModelOptions]="{standalone: true}" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)">
                      @for (s of displayDropDownList(row.FORM_LINE_KEY, row.SUB_FORM); track $index) {
<option [ngValue]="s">{{s.name}}</option>
}
                    </select>
                  </td>
}
                  @if (row.ROW_TYPE === 'DT') {
<td width="10%" align="right">
                    <input [(ngModel)]="row.ATTRIB_VALUE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="setChange(row)"/>
                  </td>
}
                  @if (row.ROW_TYPE === 'LH') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                    <h4><b>{{formatNumber(row.ATTRIB_VALUE)}}</b></h4>
                  </td>
}
                  @if (row.ROW_TYPE === 'AGG') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                    <b>{{formatNumber(row.ATTRIB_VALUE)}}</b>
                  </td>
}
                  @if (row.ROW_TYPE === 'DTA') {
<td width="10%" align="right">
                    <textarea [ngModel]="row.ATTRIB_VALUE" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)" type="text" class="form-control input-xxlarge" style="width:100%"></textarea>
                  </td>
}
                </tr>
}
              
}

              <!-- FDII Section -->
              @for (row of fdiiData; track $index) {

                @if (row.LINE_NO === 'N/A' && row.IS_DISPLAY === 'Y' && row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'SH') {
<tr>
                  <td width="2%" style="background-color: #778899"></td>
                  <td [attr.colspan]="colspan" style="background-color: #778899"><b><font color="white">{{row.DESCRIPTION}}</font></b></td>
                </tr>
}
              
}
              @for (row of fdiiData; track $index) {

                @if (row.LINE_NO !== 'N/A' && row.IS_DISPLAY === 'Y') {
<tr>
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"><h4><b><font color="#808080">{{row.DISPLAY_LINE_NO}}</font></b></h4></td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"></td>
}
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"><b>{{row.DISPLAY_LINE_NO}}</b></td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"></td>
}
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td align="center" width="2%">{{row.DISPLAY_LINE_NO}}</td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td align="center" width="2%"></td>
}

                  @if (row.ROW_TYPE === 'LH') {
<td width="45%"><h4><b><font color="#808080">{{row.DESCRIPTION}}</font></b></h4></td>
}
                  @if (row.ROW_TYPE === 'AGG') {
<td width="45%"><b>{{row.DESCRIPTION}}</b></td>
}
                  @if (row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td width="45%">{{row.DESCRIPTION}}</td>
}

                  @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '11' && row.LINE_NO !== 'NK1EST') {
<td width="10%" align="right">
                    <input type="checkbox" [checked]="row.ATTRIB_VALUE === '1'" (change)="row.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
                  </td>
}
                  @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '12' && row.SUB_FORM != null) {
<td width="10%" align="right">
                    <select class="form-control" [ngModel]="row.ATTRIB_VALUE" [compareWith]="compareDropdownObj" [ngModelOptions]="{standalone: true}" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)">
                      @for (s of displayDropDownList(row.FORM_LINE_KEY, row.SUB_FORM); track $index) {
<option [ngValue]="s">{{s.name}}</option>
}
                    </select>
                  </td>
}
                  @if (row.ROW_TYPE === 'DT') {
<td width="10%" align="right">
                    <input [(ngModel)]="row.ATTRIB_VALUE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="setChange(row)"/>
                  </td>
}
                  @if (row.ROW_TYPE === 'LH') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                    <h4><b>{{formatNumber(row.ATTRIB_VALUE)}}</b></h4>
                  </td>
}
                  @if (row.ROW_TYPE === 'AGG') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                    <b>{{formatNumber(row.ATTRIB_VALUE)}}</b>
                  </td>
}
                  @if (row.ROW_TYPE === 'DTA') {
<td width="10%" align="right">
                    <textarea [ngModel]="row.ATTRIB_VALUE" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)" type="text" class="form-control input-xxlarge" style="width:100%"></textarea>
                  </td>
}
                </tr>
}
              
}

              <!-- S864C8 Section -->
              @for (row of s864c8Data; track $index) {

                @if (row.LINE_NO === 'N/A' && row.IS_DISPLAY === 'Y' && row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'SH') {
<tr>
                  <td width="2%" style="background-color: #778899"></td>
                  <td [attr.colspan]="colspan" style="background-color: #778899"><b><font color="white">{{row.DESCRIPTION}}</font></b></td>
                </tr>
}
              
}
              @for (row of s864c8Data; track $index) {

                @if (row.LINE_NO !== 'N/A' && row.IS_DISPLAY === 'Y') {
<tr>
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"><h4><b><font color="#808080">{{row.DISPLAY_LINE_NO}}</font></b></h4></td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'LH') {
<td align="center" width="2%"></td>
}
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"><b>{{row.DISPLAY_LINE_NO}}</b></td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE === 'AGG') {
<td align="center" width="2%"></td>
}
                  @if (row.IS_FORM_DISPLAY === 'Y' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td align="center" width="2%">{{row.DISPLAY_LINE_NO}}</td>
}
                  @if (row.IS_FORM_DISPLAY === 'N' && row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td align="center" width="2%"></td>
}

                  @if (row.ROW_TYPE === 'LH') {
<td width="45%"><h4><b><font color="#808080">{{row.DESCRIPTION}}</font></b></h4></td>
}
                  @if (row.ROW_TYPE === 'AGG') {
<td width="45%"><b>{{row.DESCRIPTION}}</b></td>
}
                  @if (row.ROW_TYPE !== 'LH' && row.ROW_TYPE !== 'AGG' && row.LINE_NO !== 'NK1EST') {
<td width="45%">{{row.DESCRIPTION}}</td>
}

                  @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '11' && row.LINE_NO !== 'NK1EST') {
<td width="10%" align="right">
                    <input type="checkbox" [checked]="row.ATTRIB_VALUE === '1'" (change)="row.ATTRIB_VALUE = $any($event.target).checked ? '1' : '0'; setChange(row)"/>
                  </td>
}
                  @if (row.ROW_TYPE === 'PL' && row.ATTRIB_PROP_KEY == '12' && row.SUB_FORM != null) {
<td width="10%" align="right">
                    <select class="form-control" [ngModel]="row.ATTRIB_VALUE" [compareWith]="compareDropdownObj" [ngModelOptions]="{standalone: true}" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)">
                      @for (s of displayDropDownList(row.FORM_LINE_KEY, row.SUB_FORM); track $index) {
<option [ngValue]="s">{{s.name}}</option>
}
                    </select>
                  </td>
}
                  @if (row.ROW_TYPE === 'DT') {
<td width="10%" align="right">
                    <input [(ngModel)]="row.ATTRIB_VALUE" [ngModelOptions]="{standalone: true}" onlyDigitsDecimal type="text" class="form-control input-sm numText" style="text-align: right;" (ngModelChange)="setChange(row)"/>
                  </td>
}
                  @if (row.ROW_TYPE === 'LH') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                    <h4><b>{{formatNumber(row.ATTRIB_VALUE)}}</b></h4>
                  </td>
}
                  @if (row.ROW_TYPE === 'AGG') {
<td width="10%" align="right" [class.color-red]="row.ATTRIB_VALUE < 0">
                    <b>{{formatNumber(row.ATTRIB_VALUE)}}</b>
                  </td>
}
                  @if (row.ROW_TYPE === 'DTA') {
<td width="40%" align="right">
                    <textarea [ngModel]="row.ATTRIB_VALUE" (ngModelChange)="row.ATTRIB_VALUE = $event; setChange(row)" type="text" class="form-control input-xxlarge" style="width:100%"></textarea>
                  </td>
}
                </tr>
}
              
}

            </tbody>
          </table>
        </div>
      </div>
}

    </div>
  </form>
</div>

<!-- Standard Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="saveAndPost()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save &amp; Post
  </button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
